/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobEventLimited_event$ref: FragmentReference;
declare export opaque type JobEventLimited_event$fragmentType: JobEventLimited_event$ref;
export type JobEventLimited_event = {|
  +timestamp: any,
  +job: {|
    +concurrency: ?{|
      +group: string,
      +limit: number,
    |}
  |},
  +$refType: JobEventLimited_event$ref,
|};
export type JobEventLimited_event$data = JobEventLimited_event;
export type JobEventLimited_event$key = {
  +$data?: JobEventLimited_event$data,
  +$fragmentRefs: JobEventLimited_event$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventLimited_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobTypeCommand",
      "kind": "LinkedField",
      "name": "job",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "JobConcurrency",
          "kind": "LinkedField",
          "name": "concurrency",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "group",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "limit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};
// prettier-ignore
(node/*: any*/).hash = '161b0372d78cec25341af33c18d527f9';

module.exports = node;
